import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { AiOutlineBars } from 'react-icons/ai';
import { deleteCookie } from '../../../shared/cookie';
import { checkPassword } from '../../../shared/utils/validation';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useMutation } from '@tanstack/react-query';
import theme from '../../../shared/styles/Theme';
import { Button } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { authApis } from '../../../shared/apis/auth/apis';

const MySwal: any = withReactContent(Swal);

const Header = (props: {
  sideBarClose: boolean;
  sideBarDisplay: string;
  setSideBarDisplay: Dispatch<SetStateAction<string>>;
}) => {
  // 로그아웃 api
  const logout = async () => {
    const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

    try {
      ['Authorization', 'RefreshToken'].forEach((cookieName) => {
        deleteCookie(cookieName);
        if (cookieDomain) deleteCookie(cookieName, { domain: cookieDomain });
      });
      window.location.reload();
    } catch (e) {
      alert('알 수 없는 이유로 로그아웃에 실패했습니다.');
    }
  };

  // 비밀번호 초기화 api
  const { mutate: resetPassword } = useMutation(authApis.resetPassword, {
    onSuccess: () => {
      Swal.fire({
        icon: 'success',
        title: '비밀번호 초기화에 성공하였습니다.',
        text: '다시 로그인 해주세요.',
        confirmButtonText: '확인',
      }).then(() => {
        logout();
      });
    },
  });

  const resetPasswordModal = () => {
    MySwal.fire({
      title: '비밀번호 초기화',
      html: (
        <UpdateSwal>
          <InputBox>
            <h4>현재 비밀번호</h4>
            <input id="currentPassword" type="password" placeholder="현재 비밀번호를 입력해주세요." />
          </InputBox>
          <InputBox>
            <h4>새 비밀번호</h4>
            <input id="newPassword" type="password" placeholder="새 비밀번호를 입력해주세요." />
            <p style={{ color: theme.color.error }}>비밀번호는 특수문자를 포함한 8~16자리 입니다.</p>
          </InputBox>
          <InputBox>
            <h4>비밀번호 확인</h4>
            <input id="passwordCheck" type="password" placeholder="비밀번호를 확인해주세요." />
          </InputBox>
        </UpdateSwal>
      ),
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result: { isConfirmed: boolean }) => {
      if (result.isConfirmed) {
        const currentPassword = (document.getElementById('currentPassword') as HTMLInputElement).value;
        const newPassword = (document.getElementById('newPassword') as HTMLInputElement).value;
        const passwordCheck = (document.getElementById('passwordCheck') as HTMLInputElement).value;

        if (!checkPassword(currentPassword)) {
          MySwal.fire('비밀번호는 특수문자를 포함한 8~16자리 입니다.', '', 'error');
          return;
        }
        if (newPassword !== passwordCheck) {
          MySwal.fire('입력하신 비밀번호가 서로 다릅니다.', '', 'error');
          return;
        }

        const sendData = {
          password: currentPassword,
          newPassword,
        };
        resetPassword(sendData);
      }
    });
  };

  return (
    <Wrap sideBarClose={props.sideBarClose}>
      <header>
        {/* 570px보다 작은 화면에서 햄버거바 생김 */}
        <AiOutlineBars
          onClick={() => {
            props.setSideBarDisplay('block');
          }}
        />
        <div className="header-left">통합관리자 페이지</div>
        <div className="header-right">
          <Button
            size="xs"
            px="xs"
            style={{ textDecoration: 'underline' }}
            variant="transparent"
            onClick={() => {
              window.open('https://www.edgecross.ai/');
            }}
          >
            공식 홈페이지
          </Button>
          <Button size="xs" px="xs" style={{ textDecoration: 'underline' }} variant="transparent" onClick={resetPasswordModal}>
            비밀번호 변경
          </Button>
          <Button
            size="xs"
            px="xs"
            variant="transparent"
            leftSection={<IconLogout size={14} />}
            onClick={() => {
              logout();
            }}
          >
            로그아웃
          </Button>
        </div>
      </header>
    </Wrap>
  );
};

export default Header;
const Wrap = styled.div`
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 50px;
  background-color: ${(props) => props.theme.color.bg[200]};
  padding: 20px;
  font-size: 1rem;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 2px 3px 5px 0px #e5e7eb;
  padding-left: ${(props: { sideBarClose: boolean }) => (props.sideBarClose ? '80px' : '25px')};
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  @media (max-width: ${(props) => props.theme.breakpoints.Mobile}) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-left {
      font-weight: 700;
    }
    .header-right {
      display: flex;
      gap: 6px;
      button {
        @media (max-width: ${(props) => props.theme.breakpoints.Mobile}) {
          display: none;
        }
      }
    }
  }
`;

export const UpdateSwal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 5px;
  width: 100%;
  h4 {
    font-size: 15px;
  }

  p {
    font-size: 12px;
  }
  input {
    width: 100%;
    height: 35px;
    padding: 0px 10px;
  }
  .phoneInputBox {
    display: grid;
    grid-template-columns: auto 15px auto 15px auto;
    align-items: center;
    input {
      text-align: center;
    }
  }
`;
